var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5H17.5V6.25C17.5 5.91848 17.3683 5.60054 17.1339 5.36612C16.8995 5.1317 16.5815 5 16.25 5H3.75C3.41848 5 3.10054 5.1317 2.86612 5.36612C2.6317 5.60054 2.5 5.91848 2.5 6.25V7.5ZM2.5 8.75V15C2.5 15.3315 2.6317 15.6495 2.86612 15.8839C3.10054 16.1183 3.41848 16.25 3.75 16.25H16.25C16.5815 16.25 16.8995 16.1183 17.1339 15.8839C17.3683 15.6495 17.5 15.3315 17.5 15V8.75H2.5ZM3.75 3.75H16.25C16.913 3.75 17.5489 4.01339 18.0178 4.48223C18.4866 4.95107 18.75 5.58696 18.75 6.25V15C18.75 15.663 18.4866 16.2989 18.0178 16.7678C17.5489 17.2366 16.913 17.5 16.25 17.5H3.75C3.08696 17.5 2.45107 17.2366 1.98223 16.7678C1.51339 16.2989 1.25 15.663 1.25 15V6.25C1.25 5.58696 1.51339 4.95107 1.98223 4.48223C2.45107 4.01339 3.08696 3.75 3.75 3.75Z",
    fill: "#56CDAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5V3.75H12.5V2.5H7.5ZM7.5 1.25H12.5C12.8315 1.25 13.1495 1.3817 13.3839 1.61612C13.6183 1.85054 13.75 2.16848 13.75 2.5V3.75C13.75 4.08152 13.6183 4.39946 13.3839 4.63388C13.1495 4.8683 12.8315 5 12.5 5H7.5C7.16848 5 6.85054 4.8683 6.61612 4.63388C6.3817 4.39946 6.25 4.08152 6.25 3.75V2.5C6.25 2.16848 6.3817 1.85054 6.61612 1.61612C6.85054 1.3817 7.16848 1.25 7.5 1.25Z",
    fill: "#56CDAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.23cf515a907a203377353bfe17e9a4b7.svg";
export { ForwardRef as ReactComponent };